// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mainNavigationStyles } from "@synd/Overrides/Widgets/Header/MainNavigation";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, layoutContainer } from "@synd/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        ${layoutContainer}
    `,
};

mainNavigationStyles.menuItemTypography = {
    color: "common.ui7",
    css: css`
        line-height: ${fontConfig.smallSingleLine.lineHeight};
        font-size: ${fontConfig.smallSingleLine.size}px;
    `,
};

mainNavigationStyles.mobileWrapper = {
    css: css`
        display: flex;
    `,
};

mainNavigationStyles.itemWrapper = {};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        padding: 8px 20px;
        position: relative;

        & > ${TypographyStyle} {
            ${({ boldLink }: any) =>
                boldLink &&
                css`
                    font-weight: ${fontConfig.weight.semiBold};
                `};
            & > ${IconWrapper} {
                color: ${color("common.ui7")};
            }
        }

        &[data-open],
        &:not([disabled]):hover {
            & > ${TypographyStyle} {
                color: ${color("common.ui9")};
                & > ${IconWrapper} {
                    transform: rotate(180deg);
                    color: ${color("common.ui9")};
                }
            }

            &:after {
                transform: scaleX(1);
            }
        }

        &:after {
            content: "";
            background-color: ${color("common.ui9")};
            height: 2px;
            position: absolute;
            top: 28px;
            left: 20px;
            width: calc(100% - 40px);
            transform: scaleX(0);
            transform-origin: left;
            transition: transform 0.3s ease;
        }
    `,
};
